// import { optionSelectAll } from "@/utils/commonUtils";

const danhSachNhomMenu = state => state.danhSachNhomMenu;
const nhomMenu = state => state.nhomMenu;
const nguoiDungNhomMenu = state => state.nguoiDungNhomMenu;
const quyenNhomMenu = state => state.quyenNhomMenu;
export default {
  danhSachNhomMenu,
  nhomMenu,
  nguoiDungNhomMenu,
  quyenNhomMenu
};
